import { render, staticRenderFns } from "./LeaderBoardScreen.vue?vue&type=template&id=3b61c2f4&scoped=true"
import script from "./LeaderBoardScreen.vue?vue&type=script&lang=js"
export * from "./LeaderBoardScreen.vue?vue&type=script&lang=js"
import style0 from "./LeaderBoardScreen.vue?vue&type=style&index=0&id=3b61c2f4&prod&lang=scss&scoped=true"
import style1 from "./LeaderBoardScreen.vue?vue&type=style&index=1&id=3b61c2f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b61c2f4",
  null
  
)

export default component.exports